import { render } from "./AddUserNew.vue?vue&type=template&id=06c290df"
import script from "./AddUserNew.vue?vue&type=script&lang=js"
export * from "./AddUserNew.vue?vue&type=script&lang=js"

import "./AddUserNew.vue?vue&type=style&index=0&id=06c290df&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__